export const EXCLUDED_ORGANIZATION_IDS = new Set([4, 6]);
export const EXCLUDED_CONTRACT_IDS = new Set([601, 602, 603]);
export const EXCLUDED_ORGANISM_IDS = new Set([2260, 2261, 2240, 2259]);
